import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LoadingService } from './services/shared/loading.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { NavigationError, Router } from '@angular/router';
import { AuthService } from './services/shared/auth.service';
import { SwUpdate } from '@angular/service-worker';
import { filter, map } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppDialogComponent } from './components/dialog/dialog.component';
import { CheckForUpdateService } from './services/shared/check.update.service';
@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})

export class AppComponent implements OnInit {
  title = 'cix-employer-web';

  public isLoading: boolean = false;
  constructor(
    private loadingService: LoadingService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private authService: AuthService,
    private swUpdate: SwUpdate,
    private dialog: MatDialog,
    private sw: CheckForUpdateService
  ) {
    // this.sw.checkForUpdates();
  }
  ngOnInit() {
    // Updates loading boolean
    this.loadingService.loading$.pipe(untilDestroyed(this)).subscribe((isLoading: boolean) => {
      setTimeout(() => {
        this.isLoading = isLoading
      }, 1);
    });
    this.setIdleCount();
    this.router.events
      .pipe(
        filter(evt => evt instanceof NavigationError),
        map(evt => evt as NavigationError)
      )
      .subscribe(evt => {
        if (evt.error instanceof Error && evt.error.name == 'ChunkLoadError') {
          window.location.assign(evt.url);
        }
      });
    this.swUpdate.versionUpdates
      .subscribe(evt => {
        if (evt.type === 'VERSION_READY') {
          this.dialog.open(AppDialogComponent, {
            width: '400px',
            autoFocus: false,
            data: {
              primaryText: `A new version is available, would you like to refresh?`,
              submitText: 'Refresh',
              titleText: 'New App Version'
            }
          }).afterClosed().subscribe((closedResult: any) => {
            if (closedResult) {
              document.location.reload();
            }
          });
        }
      });
  }

  private idleDialogRef: MatDialogRef<AppDialogComponent> | null = null;
  private idleCountdownInterval: ReturnType<typeof setInterval> | null = null;
  private readonly IDLE_PROMPT_SECONDS = 300;

  setIdleCount() {
    this.bnIdle.startWatching(1800).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        if (this.router.url === '/landing' || this.router.url === '/login') {
          return;
        } else {
          this.showIdlePrompt();
        }
      }
    });
  }

  private showIdlePrompt() {
    // Stop idle watching while the prompt is up so mouse movement over the
    // dialog itself doesn't silently reset the timer without an explicit answer.
    this.bnIdle.stopTimer();

    let remainingSeconds = this.IDLE_PROMPT_SECONDS;

    this.idleDialogRef = this.dialog.open(AppDialogComponent, {
      width: '400px',
      autoFocus: false,
      disableClose: true,
      data: {
        titleText: 'Are you still there?',
        primaryText: this.getIdlePromptText(remainingSeconds),
        submitText: `Yes, I'm still here`
      }
    });

    this.idleCountdownInterval = setInterval(() => {
      remainingSeconds--;
      if (remainingSeconds <= 0) {
        this.idleDialogRef?.close(false);
        return;
      }
      if (this.idleDialogRef) {
        this.idleDialogRef.componentInstance.data.primaryText = this.getIdlePromptText(remainingSeconds);
      }
    }, 1000);

    this.idleDialogRef.afterClosed().subscribe((stillActive: boolean) => {
      if (this.idleCountdownInterval) {
        clearInterval(this.idleCountdownInterval);
        this.idleCountdownInterval = null;
      }
      this.idleDialogRef = null;

      if (stillActive) {
        this.bnIdle.startWatching(1800);
      } else {
        this.router.navigate(['/login']);
        this.authService.signOut();
      }
    });
  }

  private getIdlePromptText(remainingSeconds: number): string {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    const timeStr = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    return `You've been inactive for a while. We'll sign you out in ${timeStr} unless you confirm you're still here.`;
  }
}